module.exports = __webpack_public_path__ + "static/media/covid_adolescent_p4_2.c848346f.png";